export interface Mixpanel {
  reset: () => void;
}

export interface AnalyticsGlobalTypes {
  mixpanel?: Mixpanel;
  dataLayer?: object[];
  ga?: (event: string, payload: string) => void;
  hj?: (action: string, userId?: number | string, payload?: object) => void;
}

export interface AnalyticsPageProps {
  analytics?: {
    name?: AnalyticsPageName;
    category?: AnalyticsPageCategory;
    properties?: Record<string, unknown>;
  };
}

// previously `MixPanelPages`
export enum AnalyticsPageName {
  SearchLivingPlace = 'living place',
  SearchResidentialLand = 'Residential land',
  SearchHouseOrVilla = 'House or villa',
  SearchCommercialLand = 'Commercial land',
  SearchFarmLand = 'Farm land',
  Other = 'Other',
}

export enum AnalyticsPageCategory {
  SearchResults = 'Search results page',
  Other = 'Other',
  LDP = 'listing detail page',
}

// previously `MixPanelCookies`
export enum AnalyticsCookie {
  FirstSource = 'budgetprops-mp-source',
}

export enum AnalyticsSession {
  CurrentSource = 'budgetprops-mp-source',
}

// previously `MixPanelEvent`
export enum AnalyticsEvent {
  PageViewed = 'PageViewed',
  SearchListingClicked = 'search listing clicked',
  SearchFilterApplied = 'search filter applied',
  SearchWithCity = 'Search with city',
  ClickedSearchButton = 'clicked search button',
  ClickedChangeView = 'clicked to change view on search',
  SearchSortApplied = 'search sort applied',
  ClickedGalleryLDP = 'clicked gallery slideshow',
  ClickedShowMoreLDP = 'clicked show more/less description',
  ListingFavorited = 'listing favorited',
}

// previously `MixpanelUserProperties`
export type AnalyticsUserProperties = {
  source?: string;
  currentSource?: string;
  path?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_term?: string;
  utm_content?: string;
  utm_campaign?: string;
  subscription_type?: string;
};
